// extracted by mini-css-extract-plugin
export default {"pagination":"PDFViewerBox_pagination__VEcYX","pagination_button":"PDFViewerBox_pagination_button__hn7VH","page_info":"PDFViewerBox_page_info__Bu+iS"};